"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressStepperStepLabelText = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _ProgressStepperStepLabelText = require("./ProgressStepperStepLabelText.styles");
/**
 * Used by `ProgressStepperStep` to wrap a step's label text.
 *
 * @since 8.57.0
 */
var ProgressStepperStepLabelText = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_ProgressStepperStepLabelText.StyledProgressStepperStepLabelText, (0, _extends2.default)({
    ref: forwardedRef
  }, props));
});
exports.ProgressStepperStepLabelText = ProgressStepperStepLabelText;
ProgressStepperStepLabelText.displayName = 'ProgressStepperStepLabelText';